document.addEventListener('DOMContentLoaded', function (e) {
    setTimeout(() => {
        const e = () => {
                var t = document.createElement('link');
                ((t.rel = 'stylesheet'),
                    (t.href = 'https://cdn.envybox.io/widget/cbk.css'),
                    document.head.appendChild(t));
                var c = document.createElement('script');
                ((c.type = 'text/javascript'),
                    (c.src = 'https://cdn.envybox.io/widget/cbk.js?wcb_code=562dd1225cb9bf7cc4ee6580e85907fa'),
                    document.head.appendChild(c),
                    (window._tmr || (window._tmr = [])).push({
                        id: '3355806',
                        type: 'pageView',
                        start: new Date().getTime(),
                        pid: 'USER_ID',
                    }));
            },
            t = setTimeout(e, 15e3),
            c = () => {
                (e(), clearTimeout(t));
            };
        ['mouseover', 'keydown', 'touchmove', 'touchstart'].forEach((e) =>
            window.addEventListener(e, c, {
                passive: !0,
                once: !0,
            }),
        );
    }, 2e3);
});
